export default __webpack_public_path__ + "static/HIPAA_Compliant_White-e336f151c73a9a50a4931ebe26b479f9.svg";